var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "navbar is-primary",
      attrs: { role: "navigation", "aria-label": "main navigation" },
    },
    [
      _c(
        "div",
        { staticClass: "navbar-brand" },
        [
          _c(
            "router-link",
            {
              staticClass: "navbar-item",
              attrs: { to: "/", exact: "" },
              nativeOn: {
                click: function ($event) {
                  return _vm.closeMobileNav.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                attrs: { src: "/statics/signar-white.svg", alt: "" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "navbar-burger has-text-white",
              class: { "is-active": _vm.showMobileNav },
              attrs: {
                role: "button",
                "data-target": "navMenu",
                "aria-label": "menu",
                "aria-expanded": "false",
              },
              on: { click: _vm.toggleMobileNav },
            },
            [
              _c("span", { attrs: { "aria-hidden": "true" } }),
              _vm._v(" "),
              _c("span", { attrs: { "aria-hidden": "true" } }),
              _vm._v(" "),
              _c("span", { attrs: { "aria-hidden": "true" } }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "navbar-menu",
          class: { "is-active": _vm.showMobileNav },
          attrs: { id: "navMenu" },
        },
        [
          _c(
            "div",
            { staticClass: "navbar-start" },
            [
              _vm.$store.getters.hasAnyRole(["user", "lyris"])
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: {
                        to: "/repositorio",
                        "active-class": "is-active",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeMobileNav.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-folder-open fa-fw fa-lg",
                      }),
                      _vm._v(" Repositorio\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole(["lyris", "empleador", "empleado"])
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: { to: "/recibos", "active-class": "is-active" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeMobileNav.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-file-invoice-dollar fa-fw fa-lg",
                      }),
                      _vm._v(" Recibos\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                "lyris",
                "otros-admin",
                "otros-user",
              ])
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: {
                        to: "/otros-documentos",
                        "active-class": "is-active",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeMobileNav.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-file-import fa-fw fa-lg",
                      }),
                      _vm._v(" Notificaciones\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS.ID,
                _vm.constants.STRINGS.ROLES.OFICIAL_DE_REGISTRO.ID,
                _vm.constants.STRINGS.ROLES.SUSCRIPTOR.ID,
                _vm.constants.STRINGS.ROLES.ADMINISTRADOR_DE_CERTIFICADOS.ID,
              ])
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: {
                        to: { path: _vm.getPathAccordingRol() },
                        "active-class": "is-active",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeMobileNav.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-certificate fa-fw fa-lg",
                      }),
                      _vm._v(" Autoridad Certificante\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                "admin",
                "aspec-admin",
                "serie-admin",
                "auditor",
              ])
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: {
                        to: {
                          name: "organizacionInfo",
                          params: {
                            idOrganization: _vm.userSession.user.organization,
                          },
                        },
                        "active-class": "is-active",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeMobileNav.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-building fa-fw fa-lg" }),
                      _vm._v(" Mi organización\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRole("lyris") ||
              _vm.hasRole(_vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID)
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: {
                        to: { name: "adminDashboard" },
                        "active-class": "is-active",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeMobileNav.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-wrench fa-fw fa-lg" }),
                      _vm._v("Administración\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pilaNumber
                ? _c(
                    "a",
                    {
                      staticClass: "navbar-item",
                      on: { click: _vm.openPilaProyectos },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fas fa-file-signature fa-fw fa-lg animated bounceIn",
                      }),
                      _vm._v(" \n        "),
                      _c("span", { staticClass: "tag is-rounded is-info" }, [
                        _vm._v(_vm._s(_vm.pilaNumber)),
                      ]),
                      _vm._v("  Docs a firmar\n      "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "navbar-end" },
            [
              _c(
                "article",
                {
                  staticClass:
                    "b-tag-list is-flex m-0 is-align-items-center is-justify-content-start",
                },
                [
                  _vm.hasRole(_vm.constants.STRINGS.ROLES.LYRIS.ID)
                    ? _c(
                        "b-tag",
                        {
                          staticClass:
                            "navbar-item b-tag m-1 px-3 has-text-weight-medium ml-3",
                          attrs: {
                            type: "is-success is-light",
                            size: "is-small",
                            icon: "fas fa-user-check",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.constants.STRINGS.ROLES.LYRIS.NAME)
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRole(_vm.constants.STRINGS.ROLES.LYRIS_OR.ID)
                    ? _c(
                        "b-tag",
                        {
                          staticClass:
                            "navbar-item b-tag m-1 px-3 has-text-weight-medium",
                          attrs: {
                            type: "is-primary is-light",
                            size: "is-small",
                            icon: "fas fa-user-check",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.constants.STRINGS.ROLES.LYRIS_OR.NAME)
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRole(_vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID)
                    ? _c(
                        "b-tag",
                        {
                          staticClass:
                            "navbar-item b-tag m-1 px-3 has-text-weight-medium",
                          attrs: {
                            type: "is-warning is-light",
                            size: "is-small",
                            icon: "fas fa-user-check",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.NAME
                              )
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.userSession
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: { to: { name: "customSettings" } },
                    },
                    [
                      _c("i", { staticClass: "fas fa-cog fa-lg fa-fw" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "is-hidden-desktop" }, [
                        _vm._v(" Configuración"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userSession &&
              _vm.userHasCertificate &&
              (_vm.userCertificateIsAboutToExpired ||
                _vm.userCertificateIsExpired)
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: { to: { path: "/ac/certificados" } },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-exclamation-triangle fa-lg fa-fw",
                        class: {
                          "has-text-warning":
                            _vm.userCertificateIsAboutToExpired,
                          "has-text-danger animated flash":
                            _vm.userCertificateIsExpired,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "is-hidden-desktop" }, [
                        _vm._v(" Revise su certificado"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userSession
                ? _c(
                    "router-link",
                    {
                      staticClass: "navbar-item",
                      attrs: { to: { name: "perfilInformacion" } },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-user-circle fa-lg fa-fw",
                      }),
                      _vm._v(" \n          "),
                      _c("span", { staticClass: "is-uppercase" }, [
                        _c("b", [_vm._v(_vm._s(_vm.userSession.user.surname))]),
                      ]),
                      _vm._v(
                        ",  " + _vm._s(_vm.userSession.user.name) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userSession
                ? _c(
                    "a",
                    {
                      staticClass: "navbar-item",
                      on: {
                        click: function ($event) {
                          return _vm.logout()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-sign-out-alt fa-fw fa-lg",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "is-hidden-desktop" }, [
                        _vm._v(" Cerrar sesión"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.userSession
                ? _c(
                    "router-link",
                    { staticClass: "navbar-item", attrs: { to: "/login" } },
                    [
                      _c("i", {
                        staticClass: "fas fa-sign-in-alt fa-fw fa-lg",
                      }),
                      _vm._v(" Entrar\n      "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }